import Immutable from 'immutable';
import { RawUserProfile, UserProfile } from './UserProfile';

export type UserId = string;
export type UserEmail = string;

export interface RawUser {
  id: UserId;
  email: UserEmail;
  profile: RawUserProfile;
}

export interface UserData {
  id: UserId;
  email: UserEmail;
  profile: UserProfile;
}

const defaultValues: UserData = {
  id: '',
  email: '',
  profile: new UserProfile(),
};

export const UserFactory = Immutable.Record(defaultValues, 'User');

export class User extends UserFactory {
  static deserialize(rawUser: RawUser): User {
    return new User({
      ...rawUser,
      // For the getProject call, user return null. This should be fixed in the future.
      profile: UserProfile.deserialize(rawUser?.profile),
    });
  }

  serialize(): RawUser {
    return this.toJS();
  }
}

export type UserList = Immutable.List<User>;

export type UserMap = Immutable.OrderedMap<UserId, User>;
